import { usePaginatedApi } from "../../../swr/useApi";
import { documentsService } from "../../api_client";
import type { DocumentDto, DocumentsQueryDto } from "../../../api";

export function useDocuments(query?: DocumentsQueryDto) {
    return usePaginatedApi<DocumentDto, DocumentsQueryDto>({
        key: "documents",
        serviceMethod: async (queryParams) => {
            return await documentsService.getDocuments(queryParams);
        },
        query: query,
    });
}

